export const mission = {
  title: "Redefining Excellence in Crewing and Logistics",
  subtitle: "Talk to us now about your crewing and logistics needs.",
  body: "At Access Crewing Services, we specialise in providing seamless crewing and logistics services to the oil, gas, and renewable industries.\nWith a focus on reliability and efficiency, we partner with businesses to streamline recruitment, compliance, data management, and crew retention.",
};

export const whoWeAre = {
  title: "Our Expertise, Your Advantage",
  body: "Helen Dawson, founder of Access CV and Access Crewing Solutions, brings over 20 years of experience managing complex projects and teams across diverse sectors. From developing policies for structural engineering firms to supporting offshore operations, Helen’s expertise ensures that Access delivers solutions tailoured to your specific project needs.",
  cta: { text: "Send Us a Message", url: "/contact" },
};
export const whyAccessCV = {
  title: "Why Choose Access CV",
  subtitle:
    "From initial project planning to final execution, we're here to guide you in your crewing and logistic needs, every step of the way.",
  content: [
    {
      title: "Experienced Leadership",
      body: "With years of expertise in offshore industries, our team brings deep knowledge and a track record of success to every project.",
    },
    {
      title: "Tailored Solutions",
      body: "We understand that no two operations are the same. Our customised strategies ensure we meet your specific needs with precision and efficiency.",
    },
    {
      title: "Proactive Problem-Solving",
      body: "Anticipating challenges before they arise, we provide proactive solutions to ensure uninterrupted operations.",
    },
    {
      title: "Innovative Technology",
      body: "We leverage advanced tools and systems for efficient crew management, data protection, and logistics coordination.",
    },
    {
      title: "Sustainability Commitment",
      body: "Dedicated to supporting the renewable energy sector, we prioritise environmentally responsible practices in all our operations.",
    },
  ],
};

export const location = {
  body: "Access CV is proudly based in the heart of the Tees Valley, a region renowned for its rich industrial heritage and vibrant community spirit. We are deeply committed to supporting our local economy, working exclusively with trusted local vendors and celebrating the talent and resilience of our home. Our roots inspire us to deliver exceptional services with a personal touch, making a positive impact both locally and globally.",
};
